import { useTranslation } from 'react-i18next';
import { StyledTitle } from './StyledTitle';
import { GreetingBox } from './styledComponent';
import { useBreakpoint } from 'hooks';

type WelcomeMessageProps = {
  pageName?: string;
  showicon?: boolean;
};

export const WelcomeMessage = (props: WelcomeMessageProps) => {
  const { t } = useTranslation();
  const { lg } = useBreakpoint();

  return (
    <GreetingBox isReminder={false} span={props.showicon ? 16 : 24}>
      <StyledTitle
        color="var(--white)"
        level={5}
        fontSize={lg ? '33px' : '26px'}
        fontFamily={'Roboto400'}
        fontWeight={'400'}
      >
        {t(props.pageName || '')}
      </StyledTitle>
    </GreetingBox>
  );
};
